import { initPayPledgeMap } from '../../pledge-pay/pay-pledge-map';
import { setPledgeMembersNameMap } from './pledge-members-lookup';
import { registerPledgesConfig } from './runtime-registry';

export const pledgesConfig = {
    memberId: null,
    pledgesListUrl: '',
    pledgesDataUrl: '',
    basePledgesListUrl: '',
    basePledgesDataUrl: '',
    routes: null,
    csrfToken: '',
    campaignObj: null,
    members: null,
    memberSearchRelatedIds: null,
    columnVisibility: null,
};

export let campaignFilterOptions = [];
export let campaignFilterOptionCount = 0;
export let perColumnSearchConfig = null;

function requirePledgesConfigObject(raw) {
    if (!raw || typeof raw !== 'object') {
        throw new Error('initPledgesConfig: config is required');
    }
    return raw;
}

function requireNonEmptyString(value, label) {
    const text = String(value ?? '').trim();
    if (!text) {
        throw new Error('initPledgesConfig: ' + label + ' is required');
    }
    return text;
}

function requireObject(value, label) {
    if (!value || typeof value !== 'object' || Array.isArray(value)) {
        throw new Error('initPledgesConfig: ' + label + ' is required');
    }
    return value;
}

function relatedIdsMap(value) {
    if (!value || typeof value !== 'object' || Array.isArray(value)) {
        return {};
    }
    return value;
}

function requireArray(value, label) {
    if (!Array.isArray(value)) {
        throw new Error('initPledgesConfig: ' + label + ' is required');
    }
    return value;
}

function requireNumber(value, label) {
    const number = Number(value);
    if (!Number.isFinite(number)) {
        throw new Error('initPledgesConfig: ' + label + ' is required');
    }
    return number;
}

function requireColumnVisibility(value) {
    const columnVisibility = requireObject(value, 'columnVisibility');
    requireNonEmptyString(columnVisibility.gridId, 'columnVisibility.gridId');
    const columns = columnVisibility.config;
    if (!Array.isArray(columns) || columns.length === 0) {
        throw new Error('initPledgesConfig: columnVisibility.config is required');
    }
    requireNonEmptyString(columnVisibility.pageIdentifier, 'columnVisibility.pageIdentifier');
    requireNonEmptyString(columnVisibility.saveUrl, 'columnVisibility.saveUrl');
    requireNonEmptyString(columnVisibility.loadUrl, 'columnVisibility.loadUrl');
    return columnVisibility;
}

function applyPledgesConfigRaw(raw) {
    const source = requirePledgesConfigObject(raw);

    pledgesConfig.memberId = source.memberId ?? null;
    pledgesConfig.pledgesListUrl = requireNonEmptyString(source.pledgesListUrl, 'pledgesListUrl');
    pledgesConfig.pledgesDataUrl = requireNonEmptyString(source.pledgesDataUrl, 'pledgesDataUrl');
    pledgesConfig.basePledgesListUrl = requireNonEmptyString(source.basePledgesListUrl, 'basePledgesListUrl');
    pledgesConfig.basePledgesDataUrl = requireNonEmptyString(source.basePledgesDataUrl, 'basePledgesDataUrl');
    pledgesConfig.routes = requireObject(source.routes, 'routes');
    pledgesConfig.csrfToken = requireNonEmptyString(source.csrfToken, 'csrfToken');
    pledgesConfig.campaignObj = requireObject(source.campaignObj, 'campaignObj');
    pledgesConfig.members = requireObject(source.members, 'members');
    pledgesConfig.memberSearchRelatedIds = relatedIdsMap(source.memberSearchRelatedIds);
    setPledgeMembersNameMap(pledgesConfig.members);
    pledgesConfig.columnVisibility = requireColumnVisibility(source.columnVisibility);

    campaignFilterOptions = requireArray(source.pledgesCampaignFilterOptions, 'pledgesCampaignFilterOptions');
    campaignFilterOptionCount = requireNumber(source.pledgesCampaignFilterOptionCount, 'pledgesCampaignFilterOptionCount');
    perColumnSearchConfig = requireObject(source.perColumnSearchConfig, 'perColumnSearchConfig');

    initPayPledgeMap(
        Array.isArray(source.payPledgeMap) && source.payPledgeMap.length === 0
            ? {}
            : requireObject(source.payPledgeMap, 'payPledgeMap')
    );
}

export function initPledgesConfig(raw) {
    applyPledgesConfigRaw(raw);
    registerPledgesConfig(pledgesConfig);
    return pledgesConfig;
}
